import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "../../lib/api";

export const AdminRouteGuard = ({ children }) => {
  const location = useLocation();
  const passcode = React.useMemo(() => new URLSearchParams(location.search).get("passcode") || "", [location.search]);
  const [checking, setChecking] = React.useState(true);
  const [allowed, setAllowed] = React.useState(false);

  React.useEffect(() => {
    let mounted = true;

    const verify = async () => {
      if (!passcode) {
        if (mounted) {
          setAllowed(false);
          setChecking(false);
        }
        return;
      }

      setChecking(true);
      try {
        await api.get("/admin/auth", { params: { passcode } });
        if (mounted) setAllowed(true);
      } catch (_) {
        if (mounted) setAllowed(false);
      } finally {
        if (mounted) setChecking(false);
      }
    };

    verify();
    return () => {
      mounted = false;
    };
  }, [passcode]);

  if (checking) {
    return <div className="mx-auto max-w-3xl px-4 py-10 text-sm text-slate-500" data-testid="admin-route-guard-loading">Verifying admin access…</div>;
  }

  if (!allowed) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};
